export const User = {
  state: {
    is_login: localStorage.getItem('is_login'),
    token: localStorage.getItem('token'),
    uid: localStorage.getItem('uid')
  },
  mutations: {
    setUid (state, uid) {
      state.uid = uid
    },
    setToken (state, token) {
      state.token = token
    },
    setIsLogin (state, status) {
      state.is_login = status
    }
  },
  getters: {
    getToken (state) {
      return state.token
    },
    getUid (state) {
      return state.uid
    },
    getIsLogin (state) {
      return state.is_login
    }
  }
}
